// YERİ: src/app/domains/site/sections/gallery.section.ts
// Galeri bölümü — site içine görsel ızgarası eklemek için. config.images[] (url + caption).
// Tüm sektörlerde kullanılabilir; tema CSS vars ile başlık renklenir.

import { inject, Component, computed, input } from '@angular/core';
import { SiteConfig, cfg } from './section.model';
import { TranslocoPipe } from '@jsverse/transloco';
import { SiteChromeText } from '../core/site-chrome-text';

interface GalleryImage { url: string; caption?: string; }

@Component({
  selector: 'sec-gallery',
  standalone: true,
  imports: [TranslocoPipe],
  template: `
    <section id="gallery" class="bg-white py-24 dark:bg-neutral-950">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        @if (title() || eyebrow()) {
          <div class="mx-auto mb-14 max-w-2xl text-center">
            @if (eyebrow()) { <p class="text-sm font-semibold uppercase tracking-widest" style="color:var(--site-accent)">{{ eyebrow() }}</p> }
            <h2 class="mt-3 font-[family-name:var(--site-head-font)] text-3xl font-bold tracking-tight text-neutral-900 dark:text-white sm:text-4xl">{{ title() }}</h2>
            @if (subtitle()) { <p class="mt-4 text-lg text-neutral-600 dark:text-neutral-400">{{ subtitle() }}</p> }
          </div>
        }

        @if (visibleImages().length) {
          <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            @for (img of visibleImages(); track $index) {
              <figure class="group relative overflow-hidden rounded-2xl bg-neutral-100 dark:bg-neutral-900"
                      [class]="$index % 5 === 0 ? 'sm:col-span-2 sm:row-span-2' : ''">
                <img [src]="img.url" [alt]="img.caption || ''" loading="lazy"
                     class="h-full w-full object-cover transition duration-500 group-hover:scale-105" [style.aspect-ratio]="$index % 5 === 0 ? '16/10' : '4/3'" />
                @if (img.caption) {
                  <figcaption class="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-4 text-sm font-medium text-white opacity-0 transition group-hover:opacity-100">{{ img.caption }}</figcaption>
                }
              </figure>
            }
          </div>
        } @else {
          <div class="rounded-2xl border-2 border-dashed border-neutral-200 py-20 text-center text-sm text-neutral-400 dark:border-neutral-800">
            {{ 'siteEditor.noImages' | transloco }}
          </div>
        }
      </div>
    </section>
  `,
})
export class GallerySection {
  protected text = inject(SiteChromeText);
  config = input<SiteConfig>({});
  protected eyebrow = computed(() => cfg(this.config(), 'eyebrow', this.text.t('sd.galeri')));
  protected title = computed(() => cfg(this.config(), 'title', this.text.t('fb.calismalarimizdanKareler')));
  protected subtitle = computed(() => cfg(this.config(), 'subtitle', ''));
  protected images = computed<GalleryImage[]>(() => cfg<GalleryImage[]>(this.config(), 'images', []));

  /**
   * ADRESİ OLAN kareler. Eskiden yalnız dizinin UZUNLUĞUNA bakılıyordu;
   * yalnız başlık taşıyan (url'siz) bir galeri "dolu" sayılıyor ve
   * <img src="undefined"> çiziliyordu — kırık görsel ikonu, boş durum
   * mesajı yerine. Şablonlar galeriyi başlıklarla tanımlayabildiği için
   * bu hâl gerçekten oluşuyordu.
   */
  protected visibleImages = computed<GalleryImage[]>(
    () => this.images().filter(i => !!i?.url && i.url.trim() !== ''));
}
